import {ThemeProvider} from 'emotion-theming';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import * as WebFont from 'webfontloader';
import App from './App';
import './App.css';
import './reset.css';
import StateProvider from './StateProvider';
import theme from './theme';

WebFont.load({
  google: {
    families: ['Barlow:300,300i,400,400i,700,700i:vietnamese']
  }
});

ReactDOM.render(
  <StateProvider>
    <ThemeProvider theme={theme}>
      <App />
    </ThemeProvider>
  </StateProvider>,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.tsx